import { CreateTenantDto, TenantDto, TenantsApi } from '../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

export const useCreateTenant = (
  tenantsApi: TenantsApi,
  onError: (err: ErrorResponse) => void,
  onSuccess: ({
    data: { name },
  }: {
    data: {
      name: string;
    };
  }) => void,
): UseMutationResult<AxiosResponse<TenantDto>, ErrorResponse, CreateTenantDto> =>
  useMutation((createTenantDto: CreateTenantDto) => tenantsApi.createTenant(createTenantDto), {
    onSuccess,
    onError,
  });
